export default __webpack_public_path__ + "static/media/008-circle-green.d5dd17e8.svg";